// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollstyle::-webkit-scrollbar {
  width: 4px; /* Width of the scrollbar */
  height: 4px; /* Height of the scrollbar for horizontal scrollbars */
}

.scrollstyle::-webkit-scrollbar-track {
  background: #f1f1f1; /* Scrollbar track color */
}

.scrollstyle::-webkit-scrollbar-thumb {
  background: #5d7ca4; /* Scrollbar thumb color */
  border-radius: 4px;
}

.scrollstyle::-webkit-scrollbar-thumb:hover {
  background: #555; /* Thumb color on hover */
}

.scrollstyle {
  scrollbar-color: #5d7ca4 #f1f1f1; /* Firefox: Thumb and track color */
}

-webkit-scrollbar {
  width: 1px;
  height: 1px;
}

-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  border-radius: 1px;
}

-webkit-scrollbar-thumb {
  border-radius: 1px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

.pagesTop {
  padding: 0;
  position: fixed;
  top: 50px;
  width: 100%;
  z-index: 99999999;
}

ion-toolbar {
  z-index: 5;
  --background: var(--main-top);
  padding: 0;
  color: var(--main-top-text);
  --ion-toolbar-color: var(--main-top-text);
}
ion-toolbar ion-buttons ion-button.button-clear {
  --color: var(--main-top-text);
  --color-activated: var(--main-top-text);
}
ion-toolbar ion-buttons ion-button {
  --border-radius: 0;
  height: 100%;
}

.flexDiv {
  position: relative;
  display: flex;
}

.tablePagesFixedDiv {
  position: fixed;
  left: 0;
  top: 50px;
  z-index: 1111;
  width: 100%;
}

ion-toolbar.submain-toolbar {
  --ion-toolbar-color: var(-background-text);
  --background: var(-background);
  --min-height: auto;
}
ion-toolbar.submain-toolbar ::ng-deep ion-segment {
  margin: 0;
}
ion-toolbar.submain-toolbar ::ng-deep ion-segment-button, ion-toolbar.submain-toolbar .md ion-segment-button {
  --color-focused: var(--main-top-text);
  --color-checked: var(--main-top-text);
  --color: var(--main-top-text);
  background: var(--main-top);
}
ion-toolbar.submain-toolbar ::ng-deep.ios ion-segment-button {
  --background-focused: var(--main-top);
  --background-checked: var(--main-top);
  --color-focused: var(--main-top-text);
  --color-checked: var(--main-top-text);
  --color: var(--main-top);
}

ion-menu-button {
  --color: var(--main-top-text);
}

ion-title {
  height: 100%;
}

.genericModalhide > ion-card {
  overflow: scroll;
  width: 100%;
  height: 700px;
}

.genericModalhide {
  width: 0px;
  z-index: 111;
  height: 800px;
  transition: width 1s ease-in-out;
}

.genericModal {
  position: fixed;
  top: 60px;
  width: 650px;
  right: 0;
  height: 1000px;
  background: #2a2d45;
  transition: width 1s ease-in-out;
}

.onSideTableContainer {
  height: 600px;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/admin-model/admin-model.page.scss"],"names":[],"mappings":"AAAA;EACE,UAAA,EAAA,2BAAA;EACA,WAAA,EAAA,sDAAA;AACF;;AAEA;EACE,mBAAA,EAAA,0BAAA;AACF;;AAEA;EACE,mBAAA,EAAA,0BAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA,EAAA,yBAAA;AACF;;AAEA;EACE,gCAAA,EAAA,mCAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;AACF;;AAEA;EACE,oDAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oDAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EAEE,UAAA;EAEA,6BAAA;EACA,UAAA;EAEA,2BAAA;EACA,yCAAA;AAFF;AAIE;EACE,6BAAA;EACA,uCAAA;AAFJ;AAKE;EACE,kBAAA;EACA,YAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,aAAA;AAJF;;AAOA;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAJF;;AAOA;EACE,0CAAA;EACA,8BAAA;EACA,kBAAA;AAJF;AAME;EACE,SAAA;AAJJ;AAOE;EACE,qCAAA;EACA,qCAAA;EAEA,6BAAA;EACA,2BAAA;AANJ;AASE;EACE,qCAAA;EACA,qCAAA;EAEA,qCAAA;EACA,qCAAA;EACA,wBAAA;AARJ;;AAYA;EACE,6BAAA;AATF;;AAYA;EAGE,YAAA;AAXF;;AAkBA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAfF;;AAkBA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;AAfF;;AAkBA;EACE,aAAA;AAfF","sourcesContent":[".scrollstyle::-webkit-scrollbar {\n  width: 4px; /* Width of the scrollbar */\n  height: 4px; /* Height of the scrollbar for horizontal scrollbars */\n}\n\n.scrollstyle::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Scrollbar track color */\n}\n\n.scrollstyle::-webkit-scrollbar-thumb {\n  background: #5d7ca4; /* Scrollbar thumb color */\n  border-radius: 4px;\n}\n\n.scrollstyle::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Thumb color on hover */\n}\n\n.scrollstyle {\n  scrollbar-color: #5d7ca4 #f1f1f1; /* Firefox: Thumb and track color */\n}\n\n-webkit-scrollbar {\n  width: 1px;\n  height: 1px;\n}\n\n-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);\n  border-radius: 1px;\n}\n\n-webkit-scrollbar-thumb {\n  border-radius: 1px;\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);\n}\n\n.pagesTop {\n  padding: 0;\n  position: fixed;\n  top: 50px;\n  width: 100%;\n  z-index: 99999999;\n}\n\nion-toolbar {\n  //box-shadow: var(--toolbar-shadow);\n  z-index: 5;\n\n  --background: var(--main-top);\n  padding: 0;\n\n  color: var(--main-top-text);\n  --ion-toolbar-color: var(--main-top-text);\n\n  ion-buttons ion-button.button-clear {\n    --color: var(--main-top-text);\n    --color-activated: var(--main-top-text);\n  }\n\n  ion-buttons ion-button {\n    --border-radius: 0;\n    height: 100%;\n  }\n}\n\n.flexDiv {\n  position: relative;\n  display: flex;\n}\n\n.tablePagesFixedDiv {\n  position: fixed;\n  left: 0;\n  top: 50px;\n  z-index: 1111;\n  width: 100%;\n}\n\nion-toolbar.submain-toolbar {\n  --ion-toolbar-color: var(-background-text);\n  --background: var(-background);\n  --min-height: auto;\n\n  ::ng-deep ion-segment {\n    margin: 0;\n  }\n\n  ::ng-deep ion-segment-button, .md ion-segment-button {\n    --color-focused: var(--main-top-text);\n    --color-checked: var(--main-top-text);\n\n    --color: var(--main-top-text);\n    background: var(--main-top);\n  }\n\n  ::ng-deep.ios ion-segment-button {\n    --background-focused: var(--main-top);\n    --background-checked: var(--main-top);\n\n    --color-focused: var(--main-top-text);\n    --color-checked: var(--main-top-text);\n    --color: var(--main-top);\n  }\n}\n\nion-menu-button {\n  --color: var(--main-top-text);\n}\n\nion-title {\n\n  //display: inline-block;\n  height: 100%;\n}\n\nion-content {\n  //background-color: silver;\n}\n\n.genericModalhide > ion-card {\n  overflow: scroll;\n  width: 100%;\n  height: 700px;\n}\n\n.genericModalhide {\n  width: 0px;\n  z-index: 111;\n  height: 800px;\n  transition: width 1s ease-in-out;\n}\n\n.genericModal {\n  position: fixed;\n  top: 60px;\n  width: 650px;\n  right: 0;\n  height: 1000px;\n  background: #2a2d45;\n  transition: width 1s ease-in-out;\n}\n\n.onSideTableContainer {\n  height: 600px;\n  //overflow-y: scroll;\n  //overscroll-behavior: contain;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
